/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// （暂不动态改变）1、顶部栏：
let sel1 = ".announcement-bar__content.announcement-bar__content--center";
if ($(sel1)) {
  // $(sel1).html('Free shipping on orders over $99.99');
}
// 2、所有页面
let sel2 = ".show-after-custom-js";
if ($(sel2)) {
  $(sel2).hide();
}

const changePage = (country) => {
  // 有/没有仓库的国家，处理的区别：
  // 1、（暂不做）顶部栏：
  //      有仓库的国家：加3-5天送达
  //      没有仓库的国家：只显示99包邮
  // 2、商品列表、详情页：
  //      有仓库的国家：没有特殊处理
  //      没有仓库的国家：如果不在可购买国家，商品数量设为0，禁止加购物车/购买

  // 现在有仓库的国家有：
  // 美国 US
  // 加拿大 CA
  // const warehouseCountrys = ['US', 'CA'];
  // if (warehouseCountrys.indexOf(country) !== -1) {
  //   // 1、顶部栏
  //   $(sel1).html('Free shipping on orders over $99.99. 3-5 days delivery');
  // } else {
  //   // 1、顶部栏
  //   $(sel1).html('Free shipping on orders over $99.99');
  // }

  // 2.1、商品列表页
  sel1 = ".hidden-for-custom-js";
  if ($(sel1) !== undefined) {
    for (let i = 0; i < $(sel1).length; i++) {
      sel2 = `${sel1}:eq(${i})`;
      if ($(sel2).html() !== undefined) {
        const countries = $(sel2).html().split(',');
        if (countries[0] && countries.indexOf(country) === -1) {
          sel2 = `.product-item__inventory.inventory:eq(${i})`;
          $(sel2).html('Out of stock');
          $(sel2).removeClass('inventory--high');
          $(sel2).parent().parent().find('.product-item__action-button').prop('disabled', true).removeClass('button--primary').addClass('button--disabled').html('Out of stock');
        }
      }
    }
  }

  // 2.2、商品详情页 product-variant-selector
  sel1 = ".product-form__info-content .hidden-for-custom-js";
  if ($(sel1) !== undefined && $(sel1).html()) {
    const countries = $(sel1).html().split(',');
    if (countries[0] && countries.indexOf(country) === -1) {
      sel1 = ".show-after-custom-js .product-form__inventory.inventory";
      $(sel1).html('Out of stock');
      $(sel1).removeClass('inventory--high');
      $(".quantity-selector__button").prop('disabled', true);
      $("input[name=quantity]").val(0).prop('disabled', true);
      $(".product-form__add-button").prop('disabled', true);
      $(".shopify-payment-button__button").prop('disabled', true);
    }
  }

  // 2、所有页面
  $(".show-after-custom-js").show();
  console.log('------  sacj here   --------------------')

}

let country = $.cookie('country');
if (!country) {
  $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function(data) {
    // // 美国ip
    // data['ip'] = '50.116.12.191';
    // // 加拿大ip
    // data['ip'] = '204.101.161.159';

    const isTest = false;
    // ！！！测试用，以下链接免费但每分钟只能45次
    const testUrl = 'https://ipapi.co/' + data['ip'] + '/json/';

    // 以下链接用Hedy的key，只有1000次
    const prdUrl = 'https://geo.ipify.org/api/v2/country?apiKey=at_W9m780ZhHYhRbQ5Bpnyu3gf94M3eK&ipAddress=' + data['ip'];

    $.getJSON(isTest ? testUrl : prdUrl, function (res) {
      country = isTest ? res['country_code'] : res['location']['country'];
      $.cookie('country', country, { expires: 31, path: '/' });
      changePage(country);
    });
  });
} else {
  changePage(country)
}
